<template>
  <el-dialog
    top="80px"
    title="Danh sách các tiện nghi"
    class="services-popup"
    width="780px"
    :visible="visible"
    :close-on-click-modal="false"
    :append-to-body="appendToBody"
    @close="$emit('close')"
  >
    <div v-if="!groupFacility.length" class="empty-content">
      <p>Hiện tại chưa có thông tin các tiện nghi</p>
    </div>
    <div v-else class="facility-content">
      <div v-for="group in groupFacility" :key="group.id" class="facility-group">
        <div class="group-header">
          <h3 class="group-title">{{ group.name }}</h3>
          <el-checkbox
            v-model="group.checkAll"
            :indeterminate="group.isIndeterminate"
            size="medium"
            @change="(val) => handleGroupCheckAllChange(group, val)"
          >Chọn tất cả</el-checkbox>
        </div>
        <el-row :gutter="24">
          <el-col
            v-for="facility in group.facilities"
            :key="facility.id"
            :lg="12"
            class="facility-col"
          >
            <el-checkbox
              v-model="facility.checked"
              border
              size="large"
              class="facility-checkbox"
              @change="() => handleCheckboxChange(group)"
            >{{ facility.name }}</el-checkbox>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-row
      slot="footer"
      class="footer pt-3"
      type="flex"
      justify="space-between"
      align="center"
    >
      <el-checkbox
        v-model="selectAll"
        size="medium"
        @change="handleSelectAll"
      >Chọn tất cả</el-checkbox>
      <el-button type="primary" @click="handleCompleted">Hoàn tất</el-button>
    </el-row>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { getTranslation } from '@/utils/filters'

function getFacilityGroupId(facility) {
  if (!facility) return null
  if (facility.group && typeof facility.group === 'object') {
    return facility.group.slug || facility.group.id
  }
  return (
    facility.group_slug ||
    facility.group ||
    facility.group_id ||
    facility.place_facility_group_id ||
    facility.facility_group_id ||
    facility.parent_id ||
    null
  )
}

export default {
  name: 'FacilityPopup',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    allFacility: {
      type: Array,
      default: () => []
    },
    selectedFacility: {
      type: Array,
      default: () => []
    },
    placeType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      groupFacility: [],
      selectAll: false
    }
  },
  computed: {
    ...mapGetters(['constant', 'language']),
    currentPlaceType() {
      return (
        this.placeType ||
        (this.$route && this.$route.meta && this.$route.meta.data && this.$route.meta.data.type) ||
        (this.$route && this.$route.query && this.$route.query.place_type) ||
        ''
      )
    },
    facilityGroups() {
      const constants = (this.constant && this.constant.constants) || {}
      const groups =
        constants.place_facility_groups ||
        constants.facility_groups ||
        constants.facilityGroups ||
        []
      return groups.map((g) => ({
        ...g,
        name: (getTranslation(g, this.language) && getTranslation(g, this.language).name) || g.name
      }))
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.buildGroupFacility()
      }
    },
    allFacility: {
      deep: true,
      handler() {
        if (this.visible) {
          this.buildGroupFacility()
        }
      }
    },
    selectedFacility: {
      deep: true,
      handler() {
        if (this.visible) {
          this.buildGroupFacility()
        }
      }
    },
    currentPlaceType() {
      if (this.visible) {
        this.buildGroupFacility()
      }
    }
  },
  mounted() {
    if (this.visible) {
      this.buildGroupFacility()
    }
  },
  methods: {
    buildGroupFacility() {
      const targetType = this.currentPlaceType
      const rawFacilities = (this.allFacility && this.allFacility.length > 0)
        ? this.allFacility
        : ((this.constant && this.constant.constants && this.constant.constants.place_facilities) || [])

      const filtered = targetType
        ? rawFacilities.filter((f) => !f.place_type || f.place_type === targetType)
        : rawFacilities

      const facilities = filtered.map((s) => ({
        ...s,
        name: (getTranslation(s, this.language) && getTranslation(s, this.language).name) || s.name,
        checked: this.selectedFacility ? this.selectedFacility.includes(s.id) : false
      }))

      const matchedFacilityIds = new Set()
      const result = []

      this.facilityGroups.forEach((group) => {
        const groupItems = facilities.filter((f) => {
          const gId = getFacilityGroupId(f)
          return (
            gId &&
            ((group.slug && (gId === group.slug || String(gId) === String(group.slug))) ||
              (group.id && (gId === group.id || String(gId) === String(group.id))))
          )
        })

        if (groupItems.length > 0) {
          groupItems.forEach((f) => matchedFacilityIds.add(f.id))
          result.push({
            ...group,
            facilities: groupItems
          })
        }
      })

      const ungrouped = facilities.filter((f) => !matchedFacilityIds.has(f.id))
      if (ungrouped.length > 0) {
        result.push({
          id: 'ungrouped',
          name: 'Tiện nghi khác',
          facilities: ungrouped
        })
      }

      result.forEach((g) => this.updateGroupState(g))
      this.groupFacility = result
      this.updateSelectAllState()
    },
    updateGroupState(group) {
      if (!group || !Array.isArray(group.facilities)) return
      const total = group.facilities.length
      const checkedCount = group.facilities.filter((f) => f.checked).length
      group.checkAll = total > 0 && checkedCount === total
      group.isIndeterminate = checkedCount > 0 && checkedCount < total
    },
    handleGroupCheckAllChange(group, val) {
      if (!group || !Array.isArray(group.facilities)) return
      group.facilities.forEach((f) => {
        f.checked = val
      })
      group.checkAll = val
      group.isIndeterminate = false
      this.updateSelectAllState()
    },
    handleCheckboxChange(group) {
      if (group) {
        this.updateGroupState(group)
      }
      this.updateSelectAllState()
    },
    handleSelectAll(val) {
      this.groupFacility.forEach((g) => {
        g.facilities.forEach((f) => {
          f.checked = val
        })
        g.checkAll = val
        g.isIndeterminate = false
      })
    },
    updateSelectAllState() {
      const all = this.groupFacility.flatMap((g) => g.facilities)
      this.selectAll = all.length > 0 && all.every((f) => f.checked)
    },
    handleCompleted() {
      this.$emit('updateFacilities', this.groupFacility)
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.services-popup {
  .empty-content {
    text-align: center;
    padding: 30px;
    color: #909399;
  }
  .facility-group {
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .group-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #ebeef5;
  }
  .group-title {
    font-size: 15px;
    font-weight: 600;
    margin: 0;
    color: #303133;
  }
  .facility-col {
    margin-bottom: 12px;
  }
  .facility-checkbox {
    width: 100%;
    margin-right: 0;
    display: flex;
    align-items: center;
    ::v-deep .el-checkbox__label {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .footer {
    border-top: 1px solid #f2f2f2;
  }
}
</style>
<style lang="scss">
.services-popup {
  .el-dialog__body {
    max-height: 60vh;
    overflow-y: auto;
  }
}
</style>
